import React from "react";
import { injectIntl } from "react-intl";
import DataGrid, { DataGridItem } from "components/data-grid";
import withStyles from "components/with-styles";
import { CustomDatepicker } from "components/form/form-datepicker";
import styles from "./styles.css.js";
import { SearchClearButton } from "components/buttons";
import PropTypes from "prop-types";
import { DeploymentAutocompleteSelect } from "components/autocomplete";
import { EventStatusSelect, EventTypeSelectMultiple } from "components/select";
import { SimpleCheckbox } from "components/form/form-checkbox/form-checkbox";

const SearchForm = ({ classes, intl, onChange, searchState, onClear }) => {
  const handleSelectChange = fieldName => valueOrObject => {
    const value = valueOrObject?.id !== undefined ? valueOrObject.id : valueOrObject;
    onChange(fieldName, value);
  };

  return (
    <DataGrid>
      <DataGridItem half>
        <div className={classes.inputWrapper}>
          <DeploymentAutocompleteSelect
            id="searchAutocomplete"
            name="deploymentId"
            placeholder={intl.formatMessage({
              id: "app.page.deployment.list.search",
            })}
            label={intl.formatMessage({
              id: "app.page.deployment.list.search.label",
            })}
            onChange={onChange}
            value={searchState.deploymentId}
            margin="normal"
          />
        </div>
      </DataGridItem>
      <DataGridItem small>
        <div className={classes.inputWrapper}>
          <CustomDatepicker
            isStart
            withTime={false}
            clearable={false}
            fullWidth
            value={searchState.startDate}
            label={intl.formatMessage({ id: "common.since" })}
            id="startDate"
            name="startDate"
            onChange={onChange("startDate")}
          />
        </div>
      </DataGridItem>
      <DataGridItem small>
        <div className={classes.inputWrapper}>
          <CustomDatepicker
            isEnd
            withTime={false}
            clearable={false}
            fullWidth
            value={searchState.endDate}
            label={intl.formatMessage({ id: "common.until" })}
            id="endDate"
            name="endDate"
            onChange={onChange("endDate")}
          />
        </div>
      </DataGridItem>
      <DataGridItem quarter>
        <div className={classes.inputWrapper}>
          <EventTypeSelectMultiple
            id="eventTypeIds"
            name="eventTypeIds"
            label={intl.formatMessage({
              id: "event.typeId",
            })}
            placeholder={intl.formatMessage({
              id: "event.eventType.placeholder",
            })}
            onChange={handleSelectChange("eventTypeIds")}
            value={searchState.eventTypeIds}
            margin="normal"
          />
        </div>
      </DataGridItem>
      <DataGridItem quarter>
        <div className={classes.inputWrapper}>
          <EventStatusSelect
            id="eventStatus"
            name="eventStatus"
            label={intl.formatMessage({
              id: "event.eventStatus",
            })}
            placeholder={intl.formatMessage({
              id: "event.eventStatus.placeholder",
            })}
            onChange={handleSelectChange("eventStatus")}
            value={searchState.eventStatus}
            margin="normal"
          />
        </div>
      </DataGridItem>
      <DataGridItem quarter>
        <div className={classes.inputWrapper}>
          <SimpleCheckbox
            id="showDeletedEvents"
            name="showDeletedEvents"
            label={intl.formatMessage({
              id: "event.list.showDeleted",
            })}
            value={JSON.parse(searchState.showDeletedEvents)}
            checked={JSON.parse(searchState.showDeletedEvents)}
            onChange={e => onChange("showDeletedEvents")(e.target.checked)}
          />
        </div>
      </DataGridItem>
      <DataGridItem quarter centered>
        <SearchClearButton className={classes.clearButton} onClick={onClear} />
      </DataGridItem>
    </DataGrid>
  );
};

SearchForm.propTypes = {
  /**
   * Estado del formulario de búsqueda
   */
  searchState: PropTypes.object,
  /**
   * Callback que se dispara con el borrado del formulario
   */
  onClear: PropTypes.func,
  /**
   * Callback que se dispara con el cambio del input
   */
  onChange: PropTypes.func,
};

export default injectIntl(withStyles(styles)(SearchForm));
